module.exports = __webpack_public_path__ + "img/fsoel-rms-home-keyvisual.06fc99b.jpg";